<template>
  <div class="reportMain">
    <Pager class="pagerMain" />
  </div>
</template>

<script>
  import Pager from '@/components/reportDesigner/Pager.vue';
  /* eslint-disable */
  
  
  export default {
    name: 'reportDesigner',
    components: {
        Pager
    },
    props: {
      
    },
    data() { 
      return {

      }
    },
    mounted() {
      
    },
    beforeDestroy() {
      
    },
    methods: {
      quickPrintCancel: async function() {
        console.log('Quick Print Cancel');
      },
    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
    },
  };
</script>

<style scoped>

  .reportMain {
    width: auto;
    height: 100%;
    padding: 20px 0 20px 40px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #EEEF;
    border: solid 1px #f000;
    overflow: none;
  }

  .pagerMain {
    width: 1200px;
    margin: 0 5px;
    box-shadow: 0 0 8px #0004;
  }

</style>